// Desktop-only logic for automation steps

document.querySelectorAll( "section.automation-steps .hidden.lg\\:block #svgContainer" ).forEach( section => {
  const cards = section.querySelectorAll( "g.card" );
  const buttons = section.querySelectorAll( "g.button" );
  let current = 0;

  function activateButtons () {
    buttons.forEach( button => {
      button.classList.remove( "active", "reverse" );
      const nums = button.dataset.num.split( "" ).map( Number );
      if ( nums.includes( current ) ) button.classList.add( "active" );
      if ( nums.includes( current - 1 ) || nums.includes( current - 2 ) ) button.classList.add( "reverse" );
    } );
  }

  function centerDesktop ( activeCard ) {
    const bbox = activeCard.getBBox();
    const cardCenterX = bbox.x + bbox.width / 2;
    if ( current === 0 ) {
      section.style.transform = `translateX(0px)`;
    } else {
      let targetCenter = 1050;
      if ( current === 1 ) targetCenter += -250;
      section.style.transform = `translateX(-${ cardCenterX - targetCenter }px)`;
    }
  }

  function activateCard () {
    cards.forEach( card => card.classList.remove( "active" ) );
    const activeCard = cards[ current ];
    if ( !activeCard ) return;
    activeCard.classList.add( "active" );
    centerDesktop( activeCard );
  }

  buttons.forEach( button => {
    const numRange = button.dataset.num || "";
    const low = Number( numRange[ 0 ] );
    const high = Number( numRange[ 1 ] );
    button.addEventListener( "click", function () {
      if ( !button.classList.contains( "active" ) ) return;
      if ( low === 0 && current !== 0 ) {
        current = 0;
      } else if ( current === low ) {
        current = high;
      } else {
        current = low;
      }
      activateCard();
      activateButtons();
    } );
  } );

  // Initialize
  activateCard();
  activateButtons();
} );
